var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "containerThumbnailSelector",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.$emit("clickOutside")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "thumbnailSelector",
          on: {
            dragover: function ($event) {
              $event.preventDefault()
              return _vm.onDragOver.apply(null, arguments)
            },
            dragleave: function ($event) {
              $event.preventDefault()
              return _vm.onDragLeave.apply(null, arguments)
            },
            drop: function ($event) {
              $event.preventDefault()
              return _vm.onDrop.apply(null, arguments)
            },
          },
        },
        [
          _vm.dragActive
            ? _c("div", { staticClass: "drop-overlay" }, [
                _c("i", { staticClass: "fa-solid fa-cloud-arrow-up" }),
                _c("p", [_vm._v("Déposez votre image")]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "ts-tabs" }, [
            _c(
              "div",
              {
                staticClass: "ts-tab",
                class: { active: _vm.tab === "upload" },
                on: {
                  click: function ($event) {
                    _vm.tab = "upload"
                  },
                },
              },
              [
                _c("i", { staticClass: "fa-solid fa-upload" }),
                _vm._v("\n                Importer une image\n            "),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "ts-tab",
                class: { active: _vm.tab === "frame" },
                on: {
                  click: function ($event) {
                    _vm.tab = "frame"
                  },
                },
              },
              [
                _c("i", { staticClass: "fa-solid fa-film" }),
                _vm._v("\n                Choisir dans la vidéo\n            "),
              ]
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tab === "upload",
                  expression: "tab === 'upload'",
                },
              ],
              staticClass: "ts-tab-content",
            },
            [
              _c("p", { staticClass: "ts-hint" }, [
                _vm._v(
                  "Choisissez une image depuis votre ordinateur ou glissez-déposez un fichier."
                ),
              ]),
              _c("input", {
                ref: "file",
                attrs: {
                  type: "file",
                  accept: "image/jpeg,image/png,image/webp",
                  hidden: "",
                },
                on: { change: _vm.onFilePicked },
              }),
              _c(
                "div",
                {
                  staticClass: "button btn-primary",
                  on: {
                    click: function ($event) {
                      return _vm.$refs.file.click()
                    },
                  },
                },
                [_vm._v("Choisir un fichier")]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tab === "frame",
                  expression: "tab === 'frame'",
                },
              ],
              staticClass: "ts-tab-content frame",
            },
            [
              _c("div", { staticClass: "preview" }, [
                _c("video", {
                  ref: "video",
                  attrs: {
                    src: _vm.effectiveVideoSrc,
                    crossorigin: "anonymous",
                    preload: "auto",
                    muted: "",
                    playsinline: "",
                  },
                  domProps: { muted: true },
                  on: { loadedmetadata: _vm.onLoaded },
                }),
                _vm.generating
                  ? _c("div", { staticClass: "loader" }, [
                      _c("i", { staticClass: "fa-solid fa-spinner fa-spin" }),
                      _vm._v(
                        "\n                    Chargement de la timeline…\n                "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "ts-timeline" }, [
                _c(
                  "div",
                  { staticClass: "strip" },
                  _vm._l(_vm.thumbs, function (thumb, i) {
                    return _c("img", {
                      key: i,
                      attrs: { src: thumb, draggable: "false" },
                    })
                  }),
                  0
                ),
                _c("div", {
                  staticClass: "cursor",
                  style: { left: _vm.cursorPercent + "%" },
                }),
                _c("input", {
                  attrs: {
                    type: "range",
                    min: "0",
                    max: _vm.durationMs || 1,
                    step: "1",
                    disabled: _vm.generating || !_vm.durationMs,
                  },
                  domProps: { value: _vm.currentMs },
                  on: { input: _vm.onScrub },
                }),
              ]),
              _c("div", { staticClass: "ts-time" }, [
                _vm._v(
                  _vm._s(_vm.formatTime(_vm.currentMs)) +
                    " / " +
                    _vm._s(_vm.formatTime(_vm.durationMs))
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "button btn-primary",
                  class: { disabled: _vm.capturing || _vm.generating },
                  on: { click: _vm.captureFrame },
                },
                [_vm._v("Utiliser cette image")]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }